import { Base } from '@studiometa/js-toolkit';

/**
 * Search Form Class
 */
export default class SearchForm extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'SearchForm',
    refs: ['inputSearch', 'resetBtn', 'form'],
  };

  /**
   * Reset form
   * @param  {object} event currentForm
   * @returns {void}
   */
  onFormReset(event) {
    event.preventDefault();

    if (this.shouldResetForm()) {
      this.$refs.inputSearch.value = '';
      this.$refs.inputSearch.focus();
      this.toggleResetButton();
    }
  }

  /**
   * On change input
   * @returns {void}
   */
  onInputSearchInput() {
    this.onChange();
  }

  /**
   * Click on reset, flush values
   * @returns {void}
   */
  onResetBtnClick() {
    this.$refs.inputSearch.value = '';
    this.hideResetBtn();
  }

  /**
   * Toggle reset btn state
   * @returns {void}
   */
  toggleResetButton() {
    const resetIsHidden = this.$refs.resetBtn.classList.contains('hidden');

    if (this.$refs.inputSearch.value.length > 0 && resetIsHidden) {
      this.showResetBtn();
    } else if (this.$refs.inputSearch.value.length === 0 && !resetIsHidden) {
      this.hideResetBtn();
    }
  }

  /**
   * Hide reset btn
   * @returns {void}
   */
  hideResetBtn() {
    this.$refs.resetBtn.classList.add('hidden');
  }

  /**
   * Show reset btn
   * @returns {void}
   */
  showResetBtn() {
    this.$refs.resetBtn.classList.remove('hidden');
  }

  /**
   * When form Changing
   * @returns {void}
   */
  onChange() {
    this.toggleResetButton();
  }

  /**
   * Should result form
   * @returns {void}
   */
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
}
